import { Button, Dialog, DialogContent } from '@mui/material';
import './style.scss';
import moment from 'moment';
import CoverPic from '../CoverPic';
import Avatar from '../Avatar';
import currency from 'currency.js';
import { useEffect, useState } from 'react';
import CountDownTimer from '../CountDownTimer';
import VerifiedTick from '../../images/tick_small_edit.png';
import styled from 'styled-components';
import { VERIFIED_STATUS } from '../../utils/constants';

const Middot = styled.span`
    content: "";
    display: inline-block;
    width: 8px;
    height: 8px;
    margin-left: 5px;
    margin-right: 5px;
    margin-bottom: 1px;
    border-radius: 50%;
    background: #5f5f5f;
    font-size: 8px;
    font-weight: 900;
`;

const PaidSubscriptionOffer = ({
    show,
    setShow,
    handleClose,
    handleFollow,
    isLoading,
    pu
}) => {
    const [promoUrl, setPromoUrl] = useState({});
    const [savings, setSavings] = useState('');
    const [timeLeft, setTimeLeft] = useState('');
    const [subscriptionPrice, setSubscriptionPrice] = useState(0);
    const [hasPromo, setHasPromo] = useState(false);

    useEffect(() => {
        if (pu.creator && pu.creator.promo_details && Object.keys(pu.creator.promo_details).length > 0) {
            setSubscriptionPrice(pu.creator.promo_details.promo_price);
            setHasPromo(true);

            if (pu.creator.promo_details.promo_duration != 0) {
                const duration = moment.utc(pu.creator.promo_details.promo_start).local()
                    .add(pu.creator.promo_details.promo_duration, 'hours');
                setTimeLeft(duration);
            } else {
                setTimeLeft('No limit');
            }
        } else {
            setSubscriptionPrice(pu.creator.subscription_price);
        }
    }, [pu]);

    const handleEndTime = () => { };

    const RenderPromoDetails = () => {
        if (hasPromo) {
            return <div className="promo">
                <div className="row">
                    <div className="col-md-12" style={{ padding: '15px 0', width: 'fit-content' }}>
                        <p className="promo-blue-header">
                            <b>Limited Offer {pu.creator.promo_details.save}% OFF! &nbsp;
                                {currency(pu.creator.promo_details.promo_price).format({ precision: 2 })}
                                USD for 1 month</b></p>
                    </div>
                </div>

                <div className={`promo-end-count ${pu.creator.promo_details.promo_limit != 0 ? 'has-promo-limit' : ''}`}>
                    <h5>Promo ends:&nbsp;
                        <span className="blue_text">
                            {
                                timeLeft === 'No limit'
                                    ? timeLeft
                                    : <CountDownTimer
                                        dateTime={timeLeft}
                                        isUTC={true}
                                        onEndTime={handleEndTime}
                                    />
                            }
                        </span>
                        <Middot />
                        Promos left: <span className="blue_text">
                            {
                                pu.creator && pu.creator.promo_details.promo_limit == 0
                                    ? 'Unlimited'
                                    : parseInt(pu.creator.promo_details.promo_limit) - parseInt(pu.creator.promo_details.promo_limit_used)
                            }</span>
                    </h5>
                </div>
            </div>;
        }

        return '';
    };

    return <Dialog
        open={show}
        onClose={handleClose}
        className='paid-subscription-offer'
        onClick={e => e.stopPropagation()}
    >
        <DialogContent
            onClick={e => e.stopPropagation()}
            style={{ padding: 0, margin: 0 }}
        >
            <div className='pu-profile'>
                <div className='pu-profile__cover'>
                    <CoverPic user={pu} />
                </div>
                <div className='pu-profile__details'>
                    <div className='details__avatar'>
                        <Avatar
                            pu={pu}
                            story={false}
                            size='120'
                        />
                    </div>
                    <div className='details__login'>
                        <strong>{pu.firstname} {pu.lastname}</strong>
                        {' '}
                        {
                            pu.verified == VERIFIED_STATUS.VERIFIED
                                ? <img src={VerifiedTick}
                                    border="0"
                                    width="24"
                                    height="24"
                                    style={{ marginLeft: '4px', marginRight: '4px' }}
                                />
                                : null
                        }
                        {' '}
                        <a
                            href='#'
                            onClick={(e) => e.preventDefault()}
                        >
                            @{pu.login}
                        </a>
                    </div>

                    <div className='details__upgrade'>
                        {
                            hasPromo
                                ? <strong>Upgrade to <span className='blue_text'>{currency(subscriptionPrice).format({ precision: 2 })}</span> for the first month</strong>
                                : <strong>Upgrade to <span className="blue_text">{currency(pu.creator.subscription_price).format({ precision: 2 })}/month</span> subscription </strong>
                        }
                        <br />
                        <strong>And get full access to:</strong>
                    </div>
                </div>
            </div>

            <div className='paid-subscription-offer__content'>
                <div className="paid-subscription-offer__lists">
                    <ul>
                        <li>My exclusive subscriber-only content</li>
                        <li>Unlimited direct messaging with me</li>
                        <li>Risk free, cancel your subscription at any time</li>
                    </ul>
                </div>

                {
                    hasPromo
                        ? <div style={{
                            marginTop: '12px',
                        }}>
                            <RenderPromoDetails />
                        </div>
                        : null
                }

                <div className='paid-subscription-offer__price'>
                    <strong className='text-blue' style={{ fontSize: '20px' }}>{currency(subscriptionPrice).format({ precision: 2 })}/month</strong><br />
                    <small>
                        Renews for {currency(pu.creator.subscription_price).format({ precision: 2 })}/month on {moment().add(1, 'months').format('MMMM DD YYYY')}.
                    </small>
                </div>

                <div className='paid-subscription-offer__action'>
                    <button
                        className="btn theme-btn theme-btn-bordered btn-follow btn-primary"
                        disabled={isLoading}
                        onClick={(e) => handleFollow(e, true)}
                        type="button"
                    >
                        {
                            !isLoading
                                ? (hasPromo
                                    ? `SUBSCRIBE FOR ${currency(subscriptionPrice).format({ precision: 2 })} ON FIRST MONTH`
                                    : `SUBSCRIBE FOR ${currency(pu.creator.subscription_price).format({ precision: 2 })}/MONTH`
                                )
                                : 'PROCESSING...'
                        }
                    </button>

                    <Button
                        fullWidth
                        disableRipple
                        variant='link'
                        onClick={handleClose}
                        sx={{
                            '&:hover': {
                                backgroundColor: 'transparent'
                            },
                            margin: '8px 0 0'
                        }}
                    >
                        No, thanks
                    </Button>
                </div>
            </div>
        </DialogContent>
    </Dialog >;
};

export default PaidSubscriptionOffer;